var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SfPrice',{attrs:{"regular":_vm.$fc(_vm.priceRange.maximum_price.regular_price.value),"special":_vm.specialPriceCalculated && _vm.$fc(_vm.specialPriceCalculated)}})}
var staticRenderFns = []

export { render, staticRenderFns }